export const PLAYER_TYPES = {
  HITTER: "position-player",
  PITCHER: "pitcher",
} as const;

export type PlayerType = (typeof PLAYER_TYPES)[keyof typeof PLAYER_TYPES];

export const PLAYER_TYPE_VALUES = [
  PLAYER_TYPES.HITTER,
  PLAYER_TYPES.PITCHER,
] as const satisfies readonly PlayerType[];

export const DEFAULT_PLAYER_TYPE = PLAYER_TYPES.HITTER;

export function isHitterType(type: PlayerType | undefined): boolean {
  return (type ?? DEFAULT_PLAYER_TYPE) === PLAYER_TYPES.HITTER;
}

export function isPitcherType(type: PlayerType | undefined): boolean {
  return type === PLAYER_TYPES.PITCHER;
}
